<ng-container *ngIf="value !== undefined">
    <div [class.text--positive]="showColors ? isPositive(value) : null" [class.text--negative]="showColors ? !isPositive(value) : null">{{ text | translate }}</div>
</ng-container>
<ng-container *ngIf="value !== undefined && compactedValue !== undefined">
    <div [class]="'d-'+breakpoint+'-none'" [class.text--positive]="showColors ? isPositive(compactedValue) : null" [class.text--negative]="showColors ? !isPositive(compactedValue) : null">{{ compactedText | translate }}</div>
</ng-container>